export default {
  getAll: {
    url: '/api/out/getAll',
    method: 'get'
  },
  create: {
    url: '/api/out/create',
    method: 'post'
  },
  update: {
    url: '/api/out/update',
    method: 'put'
  },
  delete: {
    url: '/api/out/delete',
    method: 'delete'
  },
  getExcel: {
    url: '/api/out/getExcel',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/out.js